import { IStoreState, ThunkDispatch } from '.';

import { Action } from "redux";

interface ConfigState {
  aa: {
    mode: AAMode
    proxyId: string
    hostname: string
    port: number
    endpoint: string
    callerId: string
    callerCredential: string
  },
}

export type AAMode = "proxy" | "direct" | "bypass" | null

const initialState: ConfigState = {
  aa: {
    mode: null,
    hostname: "",
    port: -1,
    proxyId: "",
    endpoint: "http://localhost:8080/AdaptiveAuthentication/services/AdaptiveAuthentication",
    callerId: "callerId",
    callerCredential: "Password1!",
  }
}

export const CONFIG_SET_PROXY = 'config/SET_PROXY'
export const CONFIG_SET_DIRECT = 'config/SET_DIRECT'
export const CONFIG_SET_AA_MODE = 'config/SET_AA_MODE'

interface ConfigSetProxyAction extends Action {
  type: typeof CONFIG_SET_PROXY
  proxyId: string
}

interface ConfigSetDirectAction extends Action {
  type: typeof CONFIG_SET_DIRECT
  endpoint: string
  callerId: string
  callerCredential: string
}

interface ConfigSetAAMode extends Action {
  type: typeof CONFIG_SET_AA_MODE
  mode: AAMode
}

export const setProxy = (proxyId: string = "") =>
  (dispatch: ThunkDispatch) => {
    dispatch({
      type: CONFIG_SET_PROXY,
      proxyId
    } as ConfigSetProxyAction)
  }

export const setDirect = (endpoint: string, callerId: string, callerCredential: string) =>
  (dispatch: ThunkDispatch) => {
    dispatch({
      type: CONFIG_SET_DIRECT,
      endpoint,
      callerId,
      callerCredential
    } as ConfigSetDirectAction)
  }

export const proxyBase = (url: string = "") =>
  (_: ThunkDispatch, getState: () => IStoreState) => {
    let state = getState()
    let config = state.config

    if (config.aa.mode === null)
      return "/"

    let prefix = "/" + config.aa.mode
    if (config.aa.mode === "proxy")
      prefix += "/" + config.aa.proxyId

    return prefix + url
  }

export const setAAMode = (mode: AAMode) =>
  (dispatch: ThunkDispatch) => {
    dispatch({
      type: CONFIG_SET_AA_MODE,
      mode
    } as ConfigSetAAMode)
  }

export default (state = initialState, action: Action) => {
  switch (action.type) {
    case CONFIG_SET_PROXY:

      return {
        ...state,
        aa: {
          ...state.aa,
          mode: "proxy",
          proxyId: (action as ConfigSetProxyAction).proxyId
        }
      } as ConfigState
    case CONFIG_SET_DIRECT:
      let directAction = action as ConfigSetDirectAction
      return {
        ...state,
        aa: {
          ...state.aa,
          mode: "direct",
          endpoint: directAction.endpoint,
          callerId: directAction.callerId,
          callerCredential: directAction.callerCredential
        }
      } as ConfigState
    case CONFIG_SET_AA_MODE:
      return {
        ...state,
        aa: {
          ...state.aa,
          mode: (action as ConfigSetAAMode).mode
        }
      }
    default:
      return state
  }
}